// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.ModalContent_modalContent__iH8o2 {
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* padding: 2rem; */
    background: #fff;
    border-radius: 12px;
  }
  
  .ModalContent_modalContentWrap__9Ogfz {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 16px;
    text-align: center;
    max-width: 320px;
  }
  
  .ModalContent_modalContentIc__v6i4K {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9e5aa;
    font-size: 32px;
  }
  
  .ModalContent_modalMessage__5ND9d {
    font-size: 17px;
    color: #333;
    font-weight: 500;
    margin: 0;
  }
  
  .ModalContent_modalActions__KnrrN {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 2rem;
  }
  
  .ModalContent_modalButton__HpWSq {
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.2s ease-in-out;
    min-width: 100px;
  }
  
  .ModalContent_cancelBtn__bufiY {
    background-color: #f1f1f1;
    color: #333;
  }
  
  .ModalContent_cancelBtn__bufiY:hover {
    background-color: #e0e0e0;
  }
  
  .ModalContent_okBtn__ANU6F {
    background-color: #007bff;
    color: white;
  }
  
  .ModalContent_okBtn__ANU6F:hover {
    background-color: #0056b3;
  }`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/LeadGenBotSettings/ModalContent.module.css"],"names":[],"mappings":";;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["\n\n.modalContent {\n    font-size: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    /* padding: 2rem; */\n    background: #fff;\n    border-radius: 12px;\n  }\n  \n  .modalContentWrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n    max-width: 320px;\n  }\n  \n  .modalContentIc {\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f9e5aa;\n    font-size: 32px;\n  }\n  \n  .modalMessage {\n    font-size: 17px;\n    color: #333;\n    font-weight: 500;\n    margin: 0;\n  }\n  \n  .modalActions {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    margin-top: 2rem;\n  }\n  \n  .modalButton {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 14px;\n    transition: all 0.2s ease-in-out;\n    min-width: 100px;\n  }\n  \n  .cancelBtn {\n    background-color: #f1f1f1;\n    color: #333;\n  }\n  \n  .cancelBtn:hover {\n    background-color: #e0e0e0;\n  }\n  \n  .okBtn {\n    background-color: #007bff;\n    color: white;\n  }\n  \n  .okBtn:hover {\n    background-color: #0056b3;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `ModalContent_modalContent__iH8o2`,
	"modalContentWrap": `ModalContent_modalContentWrap__9Ogfz`,
	"modalContentIc": `ModalContent_modalContentIc__v6i4K`,
	"modalMessage": `ModalContent_modalMessage__5ND9d`,
	"modalActions": `ModalContent_modalActions__KnrrN`,
	"modalButton": `ModalContent_modalButton__HpWSq`,
	"cancelBtn": `ModalContent_cancelBtn__bufiY`,
	"okBtn": `ModalContent_okBtn__ANU6F`
};
export default ___CSS_LOADER_EXPORT___;
